import React, { useState, Fragment } from 'react';
import { Col, Row, Button } from 'reactstrap';
import { DatePicker, KeyboardDatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import ModalUI from '../../../../../shared/components/Modal';
import { formatNumber } from '../../../../Utils/Money';



const no_op = () => { };
const ChangeCreationDateReceipt = ({ receipt, admision, setOpenModalChangeCreationDate = no_op, refreshList = no_op }) => {

    const [newCreationDate, setNewCreationDate] = useState(null);
    const [errors, setErrors] = useState({});
    const [openAlert, setOpenAlert] = useState(false);
    const [modalAlert, setModalAlert] = useState({ message: '', color: '', title: '' });
    const { fecha_ingreso_admision : dateAdmision } = admision;

    const updateCreationDateReceipt = async () => {
        let validateField = validateForm();
        let dataSend = {
            id_recibo: receipt.id_recibo,
            fecha: moment(newCreationDate).format("YYYY/MM/DD HH:mm:ss")
        };
        if (!validateField) {
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/actualizar-fecha-creacion', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            }).then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
                //return response.json();
            }).then(res => {
                console.log(res);
                setOpenAlert(true);
                setModalAlert({
                    message: "Cambio de fecha actualizado con exito",
                    color: 'success',
                    title: "Exitoso!"
                });
            }).catch((error) => {
                console.error('Error:', error);
            });
        }
    }

    const validateForm = () => {
        const errors = {};
        var error = false;
        if (newCreationDate == null) {
            errors.newCreationDate = "Campo obligatorio";
            error = true;
        }

        setErrors(errors);
        return error;
    }

    const calculateSubtotalReceipt = (copago, total) => {
        try {
            let subtotal = parseInt(copago) + parseInt(total);
            return subtotal;
        }
        catch (err) {
            console.log(err);
        }
    }

    const onOkModal = () => {
        setOpenAlert(!openAlert) 
        setOpenModalChangeCreationDate(false);
        refreshList();
    }

    return (
        <Fragment>
            <Row>
                <div className='flex-column'>
                    <div className='flex-row' style={{ flexDirection: 'row', justifyContent: 'flex-start' }}>
                        <div className='element-inside-row'><b>Recibo No.</b> {!!receipt.num_recibo ? receipt.num_recibo : 'N/A'}</div>
                        <div className='element-inside-row'><b>Admisión No.</b> {receipt.id_admision}</div>
                        <div className='element-inside-row'><b>Subtotal: </b>$ {formatNumber(calculateSubtotalReceipt(receipt.total, receipt.valor_tercero))}</div>
                        <div className='element-inside-row'><b>Copago: </b>$ {formatNumber(parseInt(receipt.total))}</div>
                        <div className='element-inside-row'><b>Total: </b>$ {formatNumber(parseInt(receipt.valor_tercero))}</div>
                    </div>
                </div>
            </Row>
            <Row>
                <Col xs={12} md={12}>
                    <MuiPickersUtilsProvider utils={MomentUtils} >
                        <DatePicker
                            required
                            value={newCreationDate}
                            onChange={(date) => setNewCreationDate(date)}
                            label="Nueva Fecha de Creación del Recibo"
                            onError={console.log}
                            minDate={moment(dateAdmision, "DD-MM-YYYY")}
                            format="yyyy/MM/DD"
                            style={{ width: '100%' }}
                            disableFuture
                            error={errors.hasOwnProperty("newCreationDate") ? errors.newCreationDate !== "" : false}
                            helperText={errors.newCreationDate}
                            autoOk={true}
                        />
                    </MuiPickersUtilsProvider>
                </Col>
            </Row>
            <Row>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        style={{ marginTop: 20 }}
                        color="primary"
                        size='sm'
                        onClick={() => {
                            setOpenModalChangeCreationDate(false);
                        }}
                    >
                        Cerrar
                    </Button>
                    <Button
                        style={{ marginTop: 20, marginLeft: 5 }}
                        color="primary"
                        size='sm'
                        onClick={() => {
                            updateCreationDateReceipt(false);
                        }}
                    >
                        Cambiar fecha
                    </Button>
                </div>
            </Row>
            {openAlert ?
                <ModalUI
                    color={modalAlert.color}
                    title={modalAlert.title}
                    message={modalAlert.message}
                    modal={openAlert}
                    toggle={() => { setOpenAlert(!openAlert) }}
                    onOk={() => { onOkModal()}}
                /> : null}
        </Fragment>
    )
}
export default ChangeCreationDateReceipt